"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var MainController = /** @class */ (function () {
    function MainController() {
    }
    return MainController;
}());
MainController.$inject = [];
exports.default = MainController;
